import React from "react";

/**
 * Full-screen blocking overlay shown while uploading new photos.
 * visible: boolean
 * total: number of photos to upload
 * current: index (0-based) of last completed (so current+1 done when current >= 0)
 * results: array of 'success' | 'rejected' | null for each index (null = pending)
 * message: optional status text
 * onCancel: optional — when set, shows a Cancel button that aborts the in-flight upload
 */
const PhotoUploadProgressOverlay = ({
  visible,
  total,
  current,
  results = [],
  message,
  onCancel,
}) => {
  if (!visible) return null;

  const done = current + 1;
  const percent = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div
      className="photo-upload-progress-overlay"
      role="progressbar"
      aria-valuenow={done}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label="Uploading photos"
    >
      <div className="photo-upload-progress-overlay-content">
        <span
          className="photo-upload-progress-overlay-spinner"
          aria-hidden="true"
        />
        <p className="photo-upload-progress-overlay-title">
          Checking photos…
        </p>
        <p className="photo-upload-progress-overlay-count">
          {done} / {total} ({percent}%)
        </p>
        <div className="photo-upload-progress-overlay-bar">
          {Array.from({ length: total }, (_, i) => {
            let segClass = "photo-upload-progress-segment";
            if (results[i] === "success") segClass += " segment-success";
            else if (results[i] === "rejected") segClass += " segment-rejected";
            else if (i <= current) segClass += " segment-done";
            return <div key={i} className={segClass} />;
          })}
        </div>
        {message && (
          <p className="photo-upload-progress-overlay-message">{message}</p>
        )}
        {typeof onCancel === "function" && (
          <button
            type="button"
            className="photo-upload-progress-overlay-cancel"
            onClick={onCancel}
          >
            Cancel upload
          </button>
        )}
      </div>
    </div>
  );
};

export default PhotoUploadProgressOverlay;
